/**
 * Pure-CSS marquee strip — accepts a list of strings.
 * Duplicates content so the loop is seamless.
 */
export default function Marquee({ items, theme = "dark" }) {
  const isDark = theme === "dark";
  const content = (
    <div className="marquee-track py-5 md:py-6">
      {[...items, ...items].map((it, i) => (
        <div key={i} className="flex items-center pr-12 md:pr-20 whitespace-nowrap">
          <span className="font-display text-3xl md:text-5xl tracking-tight uppercase">
            {it}
          </span>
          <span
            aria-hidden
            className={`mx-8 md:mx-12 inline-block h-2.5 w-2.5 rounded-full ${
              isDark ? "bg-[#C8102E]" : "bg-[#1A1A1A]"
            }`}
          />
        </div>
      ))}
    </div>
  );

  return (
    <div
      className={`overflow-hidden border-y ${
        isDark
          ? "bg-[#1A1A1A] text-[#F7F5F0] border-[#1A1A1A]"
          : "bg-[#F7F5F0] text-[#1A1A1A] border-[#D1C9BE]"
      }`}
      data-testid="marquee-strip"
    >
      {content}
    </div>
  );
}
